import Swiper, {Navigation} from "swiper"
Swiper.use([Navigation])

class SSlider {
  constructor (el) {
    this.el = el
    this.sliderEl = this.el.querySelector('.js-s-slider-container')
    this.prevBtn = this.el.querySelector('.js-s-slider-btn-prev')
    this.nextBtn = this.el.querySelector('.js-s-slider-btn-next')
    this.slider = null
    this.initDefaults()
  }

  initDefaults () {
    this.initSlider()
  }

  initSlider () {
    this.slider = new Swiper(this.sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      observer: true,
      watchOverflow: true,
      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 'auto'
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    })
  }
}

class SCard {
  constructor (el) {
    this.el = el
    this.textContainer = this.el.querySelector('.js-s-card-text-container')
    this.text = this.el.querySelector('.js-s-card-text')
    this.openBtn = this.el.querySelector('.js-s-card-open')
    this.closeBtn = this.el.querySelector('.js-s-card-close')
    this.slides = this.el.closest('.js-s-slider').querySelectorAll('.swiper-slide')
    this.cards = this.el.closest('.js-s-slider').querySelectorAll('.js-s-card')
    this.lineClamp = 4
    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
    this.onResize()
  }

  initEvents () {
    window.addEventListener('resize', () => this.onResize())
    this.openBtn.addEventListener('click', e => {
      e.preventDefault()
      this.open()
    })
    this.closeBtn.addEventListener('click', e => {
      e.preventDefault()
      this.close()
    })
    $(document).on('click', e => this.onClickOut(e))
  }
  
  onResize () {
    this.checkTextOverflow()
    if (this.el.classList.contains('open') && !this.el.classList.contains('close')) {
      this.close()
    }
  }

  checkTextOverflow () {
    if (this.el.classList.contains('open')) return;
    if (this.text.offsetHeight <= this.textContainer.offsetHeight) {
      this.el.classList.add('hide-buttons')
    } else {
      this.el.classList.remove('hide-buttons')
    }
  }

  setSlidesHeight () {
    this.slides.forEach(el => el.style.height = this.el.offsetHeight + 'px')
  }

  unsetSlidesHeight () {
    let hasOpenedCard = false
    this.cards.forEach(el => {
      if (el.classList.contains('open')) {
        hasOpenedCard = true
      }
    })

    if (hasOpenedCard) return;
    this.slides.forEach(el => el.style.height = 'auto')
  }

  open () {
    const height = this.text.offsetHeight

    this.setSlidesHeight()

    this.el.classList.add('open')
    this.textContainer.style.maxHeight = height + 'px'
    setTimeout(() => {
      this.textContainer.style.maxHeight = 'none'
    }, 300)
  }
  
  close () {
    const style = getComputedStyle(this.text)
    const lineHeight = parseInt(style.getPropertyValue('line-height').replace('px', ''))
    const height = lineHeight * this.lineClamp

    this.el.classList.add('close')
    this.textContainer.style.maxHeight = this.textContainer.offsetHeight + 'px'
    setTimeout(() => {
      this.textContainer.style.maxHeight = height + 'px'
    }, 0)
    setTimeout(() => {
      this.el.classList.remove('open')
      this.el.classList.remove('close')
      this.checkTextOverflow()
      this.unsetSlidesHeight()
    }, 350)
  }

  onClickOut (e) {
    const $target = $(e.target)
    if ( !$(this.el).is(e.target) && $(this.el).has(e.target).length === 0 ) {
      this.close()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-s-slider')
  const cards = document.querySelectorAll('.js-s-card')

  if (items.length) {
    items.forEach(el => new SSlider(el))
  }

  if (cards.length) {
    cards.forEach(el => new SCard(el))
  }
})